import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateGcrs, useGcrFormOptions } from '../api';
import { GcrForm } from '../components';

export const NewGcrPage: FC = () => {
  const navigate = useNavigate();

  const { createGcrMutation, uploadUrlData, isFetching, refetchUploadUrl } =
    useCreateGcrs();

  const { optionsData, isFetchingPrinters } = useGcrFormOptions();

  const saveGcr = async (data) => {
    if (uploadUrlData?.gcrId) {
      try {
        await createGcrMutation.mutateAsync({
          ...data,
          id: uploadUrlData.gcrId,
        });
        navigate(Routes.Gcrs, { replace: true });
        toast.success(`GCR file “${data.name}” added successfully!`);
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  const refetchUploadCredentials = async () => {
    try {
      await refetchUploadUrl();
    } catch (error) {
      toast.error('Uh oh! Something went wrong.');
    }
  };

  return (
    <GcrForm
      onSubmit={saveGcr}
      options={optionsData}
      uploadUrlData={uploadUrlData}
      refetchUploadCredentials={refetchUploadCredentials}
    >
      {({ isLoading }) => (
        <PageHeader
          title="Add New GCR File"
          asChildPage
          backPath={Routes.Gcrs}
          actions={[
            <Button
              key="create-gcr"
              type="submit"
              data-testid="create-gcr-button"
              isLoading={
                isFetching ||
                isFetchingPrinters ||
                createGcrMutation.isPending ||
                isLoading
              }
              startIcon={<PlusSquareIcon />}
            >
              Save File
            </Button>,
          ]}
        />
      )}
    </GcrForm>
  );
};
